import React, { Fragment } from 'react'
import { observer, inject } from 'mobx-react'

const ProtectedComponent = inject('userStore')(observer(props => {
  const { userStore, permission, children } = props
  if (permission && !userStore.checkPermission(permission)) {
    return null
  }
  return (
    <Fragment>
      {children}
    </Fragment>
  )
}))

export default ProtectedComponent



// WEBPACK FOOTER //
// ./src/components/generic/ProtectedComponent.js